import { iFacadeConfig } from '@andbank-myinvestor/arq/lib/basic-operation';

const config: iFacadeConfig['i18nConfig'] = {
	availableLanguages: {
		es: {
			default: 'es'
		},
		ca: {
			default: 'ca'
		},
		pt: {
			default: 'pt'
		},
		en: {
			default: 'en'
		},
		fr: {
			default: 'fr'
		},
		default: {
			default: 'es'
		}
	},
	initialLanguage: 'ca',
	fetchLanguage: false
};

export { config };
